




import { defineComponent } from '@vue/composition-api';
import AppRow from '@berlin-front/common/components/elements/AppRow';

// @vue/component
export default defineComponent({
  name: 'AtoneNgDetail',
  components: {
    AppRow,
  },

  setup() {
    return {};
  },
});
